module.exports = __webpack_public_path__ + "img/category_269.e9339103.jpg";